import { createContext, useContext } from 'react';

export const ConsumptionContext = createContext(null);

export const useConsumption = () => useContext(ConsumptionContext);
